// extracted by mini-css-extract-plugin
export default {"list":"DocumentViewSettingPopup_list__9w79u"};